import { ResponseMerchFlowApplyFilters } from "@CommonApi/merchandise";
import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetMerchflowsReviewFlows_merchflowId_ = "/merchflows/review/flows/:merchflowId";

export type ParamsGetMerchflowsReviewFlows_merchflowId_ = ExtractRouteParams<
  typeof RouteGetMerchflowsReviewFlows_merchflowId_
>;

export type ResponseGetMerchflowsReviewFlows_merchflowId_ = ResponseMerchFlowApplyFilters[];
